export default __webpack_public_path__ + "static/media/es.70d5125d.svg";